import React, { useEffect, useState } from "react";

/**
 * Fullscreen overlay dedicated to PDF export progress,
 * without changing the existing generic loader behavior.
 */
const PdfExportProgressOverlay = ({
  percent = 0,
  label = "",
  className = "",
}) => {
  const [displayedPercent, setDisplayedPercent] = useState(0);

  useEffect(() => {
    const target = Math.max(0, Math.min(100, percent));

    // Quand on atteint 100 %, on met à jour immédiatement
    // pour éviter que le téléchargement finisse avant que
    // la barre ne soit visuellement à 100 %.
    if (target >= 100) {
      setDisplayedPercent(100);
      return;
    }

    const interval = setInterval(() => {
      setDisplayedPercent((current) => {
        const diff = target - current;
        if (Math.abs(diff) < 1) {
          clearInterval(interval);
          return target;
        }
        const step = Math.sign(diff) * Math.min(Math.abs(diff), 2); // max 2% par tick
        return current + step;
      });
    }, 50); // ~20 fps

    return () => clearInterval(interval);
  }, [percent]);

  return (
    <div
      className={`fixed inset-0 bg-white/80 backdrop-blur-sm z-[1060] flex flex-col items-center justify-center ${className}`}
    >
      <div className="w-64">
        <div className="w-full h-2 bg-[#E5E7EB] rounded-full overflow-hidden">
          <div
            className="h-full bg-[#00A7A6] transition-all duration-300"
            style={{
              width: `${Math.max(0, Math.min(100, displayedPercent))}%`,
            }}
          />
        </div>
        <div className="mt-2 flex items-center justify-between text-xs text-[#0F265C]">
          <span>{label}</span>
          <span>
            {Math.max(0, Math.min(100, displayedPercent)).toFixed(0)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default PdfExportProgressOverlay;
